import {HighlightStyle, syntaxHighlighting} from "@codemirror/language";
import {EditorView} from "@codemirror/view";
import {tags} from "@lezer/highlight";

import {color, spacing} from "@khanacademy/wonder-blocks-tokens";

export const CSColors = {
    darkGrey: "#3B3B3B",
    lightGrey: "#73767D",
    purple: "#8959A8",
    red: "#991616",
    green: "#467C00",
    blue: "#1D68CA",
    brown: "#8F7000",
    orange: "#A7560B",
    lightBlueHighlight: "#1865F2",
    yellow: "#D48103",
};

const lightSettings = {
    background: "#FFFFFF",
    foreground: CSColors.darkGrey,
    cursor: CSColors.darkGrey,
    selection: `${CSColors.lightBlueHighlight}30`,
    gutterBackground: "#FFFFFF",
    gutterForeground: CSColors.lightGrey,
    lineHighlight: `${CSColors.lightGrey}30`,
    operator: CSColors.purple,
};

// SVGs for the lint markers in the gutter.
const lintMarkerIcons = {
    info: `url('data:image/svg+xml,<svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">%3Cpath%20d%3D%22M8.875%2016.875C10.4572%2016.875%2012.004%2016.4058%2013.3196%2015.5268C14.6352%2014.6477%2015.6605%2013.3983%2016.266%2011.9365C16.8715%2010.4747%2017.03%208.86613%2016.7213%207.31428C16.4126%205.76243%2015.6507%204.33697%2014.5319%203.21815C13.413%202.09933%2011.9876%201.3374%2010.4357%201.02872C8.88387%200.720037%207.27534%200.878464%205.81353%201.48396C4.35172%202.08947%203.10229%203.11485%202.22324%204.43044C1.34419%205.74603%200.875001%207.29275%200.875001%208.875C0.87724%2010.996%201.72081%2013.0296%203.22062%2014.5294C4.72042%2016.0292%206.75395%2016.8728%208.875%2016.875ZM8.875%202.10577C10.2138%202.10577%2011.5226%202.50278%2012.6358%203.24659C13.749%203.9904%2014.6166%205.04761%2015.129%206.28453C15.6413%207.52144%2015.7754%208.88251%2015.5142%2010.1956C15.253%2011.5087%2014.6083%2012.7149%2013.6616%2013.6616C12.7149%2014.6083%2011.5087%2015.253%2010.1956%2015.5142C8.88251%2015.7754%207.52144%2015.6413%206.28453%2015.129C5.04761%2014.6166%203.9904%2013.749%203.24659%2012.6358C2.50278%2011.5226%202.10577%2010.2138%202.10577%208.875C2.1078%207.08031%202.82164%205.35972%204.09068%204.09068C5.35971%202.82164%207.08031%202.10781%208.875%202.10577ZM9.49038%208.25962L9.49038%2012.5673C9.49038%2012.7305%209.42555%2012.887%209.31014%2013.0025C9.19473%2013.1179%209.03821%2013.1827%208.875%2013.1827C8.71179%2013.1827%208.55526%2013.1179%208.43985%2013.0025C8.32445%2012.887%208.25961%2012.7305%208.25961%2012.5673L8.25961%208.25962C8.25961%208.09641%208.32445%207.93988%208.43986%207.82447C8.55526%207.70907%208.71179%207.64423%208.875%207.64423C9.03821%207.64423%209.19473%207.70907%209.31014%207.82447C9.42555%207.93988%209.49038%208.09641%209.49038%208.25962ZM7.95192%205.49039C7.95192%205.30782%208.00606%205.12935%208.10749%204.97755C8.20892%204.82575%208.35308%204.70744%208.52175%204.63757C8.69042%204.56771%208.87602%204.54943%209.05508%204.58505C9.23414%204.62066%209.39862%204.70858%209.52771%204.83767C9.65681%204.96677%209.74472%205.13124%209.78034%205.3103C9.81596%205.48936%209.79768%205.67496%209.72781%205.84363C9.65795%206.0123%209.53963%206.15647%209.38783%206.2579C9.23603%206.35932%209.05757%206.41346%208.875%206.41346C8.63018%206.41346%208.3954%206.31621%208.22229%206.1431C8.04917%205.96999%207.95192%205.7352%207.95192%205.49039Z%22%20fill%3D%22%231865F2%22%2F%3E</svg>')`,
    warning: `url('data:image/svg+xml, <svg xmlns="http://www.w3.org/2000/svg" width="16" height="15" viewBox="0 0 16 15" fill="none">%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M7.06974%200.250212C7.35237%200.0863168%207.67329%200%208%200C8.32671%200%208.64763%200.0863166%208.93026%200.250212C9.2123%200.413767%209.44623%200.648785%209.60847%200.931559L9.60948%200.933326L15.7506%2011.5407C15.9137%2011.8232%2015.9997%2012.1436%2016%2012.4698C16.0003%2012.796%2015.9149%2013.1165%2015.7523%2013.3993C15.5897%2013.682%2015.3556%2013.9171%2015.0736%2014.081C14.7915%2014.2448%2014.4714%2014.3316%2014.1452%2014.3328L14.1426%2014.3328H1.85745L1.85483%2014.3328C1.52864%2014.3316%201.20849%2014.2448%200.926433%2014.081C0.644379%2013.9171%200.410333%2013.682%200.247739%2013.3993C0.0851449%2013.1165%20-0.000287422%2012.796%207.26495e-07%2012.4698C0.000290434%2012.1436%200.0862903%2011.8232%200.249385%2011.5407L6.39052%200.933326L6.39153%200.931561C6.55377%200.648785%206.7877%200.413767%207.06974%200.250212ZM7.03674%201.30314L7.68109%201.67619L1.53898%2012.2853C1.50647%2012.3417%201.48916%2012.406%201.4891%2012.4711C1.48905%2012.5363%201.50613%2012.6004%201.53865%2012.657C1.57117%2012.7136%201.61798%2012.7606%201.67439%2012.7933C1.73054%2012.826%201.79424%2012.8433%201.85917%2012.8437H14.1408C14.2058%2012.8433%2014.2695%2012.826%2014.3256%2012.7933C14.382%2012.7606%2014.4288%2012.7136%2014.4613%2012.657C14.4939%2012.6004%2014.511%2012.5363%2014.5109%2012.4711C14.5108%2012.406%2014.4937%2012.3421%2014.4612%2012.2857L8.31704%201.67296C8.28508%201.6171%208.23893%201.57068%208.18325%201.53839C8.12758%201.50611%208.06436%201.4891%208%201.4891C7.93564%201.4891%207.87243%201.50611%207.81675%201.53839C7.76108%201.57068%207.71492%201.6171%207.68295%201.67296L7.03674%201.30314ZM8.00002%205.02608C8.41123%205.02608%208.74457%205.35943%208.74457%205.77063V8.5627C8.74457%208.97391%208.41123%209.30725%208.00002%209.30725C7.58882%209.30725%207.25547%208.97391%207.25547%208.5627V5.77063C7.25547%205.35943%207.58882%205.02608%208.00002%205.02608ZM8.83765%2011.0756C8.83765%2011.5382%208.46264%2011.9132%208.00003%2011.9132C7.53743%2011.9132%207.16241%2011.5382%207.16241%2011.0756C7.16241%2010.613%207.53743%2010.238%208.00003%2010.238C8.46264%2010.238%208.83765%2010.613%208.83765%2011.0756Z%22%20fill%3D%22%23D48003%22%2F%3E</svg>')`,
    error: `url('data:image/svg+xml,<svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">%3Cpath%20d%3D%22M8.875%200.875C7.29275%200.875%205.74603%201.34419%204.43044%202.22324C3.11485%203.10229%202.08947%204.35172%201.48397%205.81353C0.878466%207.27534%200.72004%208.88387%201.02872%2010.4357C1.3374%2011.9876%202.09933%2013.413%203.21815%2014.5319C4.33697%2015.6507%205.76243%2016.4126%207.31428%2016.7213C8.86613%2017.03%2010.4747%2016.8715%2011.9365%2016.266C13.3983%2015.6605%2014.6477%2014.6352%2015.5268%2013.3196C16.4058%2012.004%2016.875%2010.4572%2016.875%208.875C16.8728%206.75395%2016.0292%204.72042%2014.5294%203.22062C13.0296%201.72081%2010.996%200.87724%208.875%200.875ZM8.875%2015.6442C7.53617%2015.6442%206.22741%2015.2472%205.11422%2014.5034C4.00103%2013.7596%203.1334%2012.7024%202.62105%2011.4655C2.1087%2010.2286%201.97465%208.86749%202.23584%207.55439C2.49703%206.24129%203.14174%205.03512%204.08843%204.08843C5.03513%203.14174%206.24129%202.49703%207.55439%202.23584C8.86749%201.97465%2010.2286%202.1087%2011.4655%202.62105C12.7024%203.13339%2013.7596%204.00102%2014.5034%205.11422C15.2472%206.22741%2015.6442%207.53617%2015.6442%208.875C15.6422%2010.6697%2014.9284%2012.3903%2013.6593%2013.6593C12.3903%2014.9284%2010.6697%2015.6422%208.875%2015.6442ZM8.25962%209.49038V5.18269C8.25962%205.01948%208.32445%204.86296%208.43986%204.74755C8.55527%204.63214%208.71179%204.56731%208.875%204.56731C9.03821%204.56731%209.19474%204.63214%209.31014%204.74755C9.42555%204.86296%209.49039%205.01948%209.49039%205.18269V9.49038C9.49039%209.65359%209.42555%209.81012%209.31014%209.92553C9.19474%2010.0409%209.03821%2010.1058%208.875%2010.1058C8.71179%2010.1058%208.55527%2010.0409%208.43986%209.92553C8.32445%209.81012%208.25962%209.65359%208.25962%209.49038ZM9.79808%2012.2596C9.79808%2012.4422%209.74394%2012.6206%209.64251%2012.7724C9.54108%2012.9242%209.39692%2013.0426%209.22825%2013.1124C9.05958%2013.1823%208.87398%2013.2006%208.69492%2013.165C8.51586%2013.1293%208.35138%2013.0414%208.22229%2012.9123C8.09319%2012.7832%208.00528%2012.6188%207.96966%2012.4397C7.93404%2012.2606%207.95232%2012.075%208.02219%2011.9064C8.09206%2011.7377%208.21037%2011.5935%208.36217%2011.4921C8.51397%2011.3907%208.69243%2011.3365%208.875%2011.3365C9.11982%2011.3365%209.3546%2011.4338%209.52771%2011.6069C9.70083%2011.78%209.79808%2012.0148%209.79808%2012.2596Z%22%20fill%3D%22%23D92916%22%2F%3E</svg>')`,
};

// SVGs used to create the wavy underline for lint errors.
const lintUnderlineImages = {
    info: `url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="6" height="3">%3Cpath%20d%3D%22m0%202.5%20l2%20-1.5%20l1%200%20l2%201.5%20l1%200%22%20stroke%3D%22%231865F2%22%20fill%3D%22none%22%20stroke-width%3D%22.7%22%2F%3E</svg>')`,
    warning: `url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="6" height="3">%3Cpath%20d%3D%22m0%202.5%20l2%20-1.5%20l1%200%20l2%201.5%20l1%200%22%20stroke%3D%22%23D48103%22%20fill%3D%22none%22%20stroke-width%3D%22.7%22%2F%3E</svg>')`,
    error: `url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="6" height="3">%3Cpath%20d%3D%22m0%202.5%20l2%20-1.5%20l1%200%20l2%201.5%20l1%200%22%20stroke%3D%22%23d92916%22%20fill%3D%22none%22%20stroke-width%3D%22.7%22%2F%3E</svg>')`,
};

const lightStyles = [
    {
        tag: tags.comment,
        color: CSColors.lightGrey,
    },
    {
        tag: [
            tags.variableName,
            tags.self,
            tags.propertyName,
            tags.attributeName,
            tags.regexp,
        ],
        color: CSColors.darkGrey,
    },
    {
        tag: [tags.number, tags.bool, tags.null],
        color: CSColors.red,
    },
    {
        tag: [tags.className, tags.typeName, tags.definition(tags.typeName)],
        color: CSColors.orange,
    },
    {
        tag: [tags.string],
        color: CSColors.green,
    },
    {
        tag: [tags.brace, tags.bracket],
        color: CSColors.purple,
    },
    {
        tag: tags.operator,
        color: lightSettings.operator,
    },
    {
        tag: [
            tags.definition(tags.propertyName),
            tags.function(tags.variableName),
            // Functions that are properties on an imported module
            tags.function(tags.propertyName),
        ],
        color: CSColors.orange,
    },
    {
        tag: tags.keyword,
        color: CSColors.blue,
    },
    {
        tag: tags.derefOperator,
        color: CSColors.darkGrey,
    },
];

/**
 * The theme we use for the code editor in light mode.
 * This theme is based on the Tomorrow theme from CodeMirror, but with
 * a few tweaks to improve color contrast for accessibility.
 * https://thememirror.net/tomorrow
 */
export const lightTheme = () => {
    const theme = EditorView.theme(
        {
            "&": {
                backgroundColor: lightSettings.background,
                color: lightSettings.foreground,
                height: "100%",
                width: "100%",
            },
            ".cm-content": {
                caretColor: lightSettings.cursor,
            },
            ".cm-cursor, .cm-dropCursor": {
                borderLeftColor: lightSettings.cursor,
            },
            "&.cm-focused .cm-scroller .cm-selectionLayer .cm-selectionBackground":
                {
                    // Multiline selection in contenteditable textarea
                    backgroundColor: lightSettings.selection,
                },
            ".cm-activeLine": {
                // Highlight the line that the cursor is on.
                backgroundColor: lightSettings.lineHighlight,
            },
            ".cm-gutters": {
                backgroundColor: lightSettings.gutterBackground,
                color: lightSettings.gutterForeground,
            },
            ".cm-activeLineGutter": {
                backgroundColor: lightSettings.lineHighlight,
            },
            ".cm-selectionMatch": {
                // When you select text, highlight all other instances of that
                // text in the editor.
                backgroundColor: lightSettings.selection,
            },
            "&.cm-focused .cm-matchingBracket": {
                // Highlight the corresponding open/close bracket when one is
                // focused.
                backgroundColor: lightSettings.selection,
            },
            ".cm-tooltip": {
                backgroundColor: color.white,
                border: "none",
                borderRadius: "4px",
                boxShadow: "0 4px 4px 0 rgba(0, 0, 0, 0.25)",
            },
            ".cm-diagnostic": {
                padding: `${spacing.medium_16}px`,
            },
            ".cm-diagnostic-info": {
                // Customize the lint tooltip for an "info" level diagnostic.
                backgroundColor: `${color.blue}08`,
                borderRadius: "4px",
                borderLeft: `6px solid ${color.blue}`,
            },
            ".cm-diagnostic-warning": {
                // Customize the lint tooltip for a "warning" level diagnostic.
                backgroundColor: `${color.gold}08`,
                borderRadius: "4px",
                borderLeft: `6px solid ${color.gold}`,
            },
            ".cm-diagnostic-error": {
                // Customize the lint tooltip for an "error" level diagnostic.
                backgroundColor: `${color.red}08`,
                borderRadius: "4px",
                borderLeft: `5px solid ${color.red}`,
            },
            ".cm-lint-marker-info": {
                // Customize the icon that appears in the gutter for an "info"
                // level diagnostic.
                content: lintMarkerIcons.info,
            },
            ".cm-lint-marker-warning": {
                // Customize the icon that appears in the gutter for a "warning"
                // level diagnostic.
                content: lintMarkerIcons.warning,
            },
            ".cm-lint-marker-error": {
                // Customize the icon that appears in the gutter for an "error"
                // level diagnostic.

                content: lintMarkerIcons.error,
            },
            ".cm-lintRange-info": {
                // Customize the color of the wavy line for an "info" level
                // diagnostic with the blue highlight color (#1865F2).

                backgroundImage: lintUnderlineImages.info,
            },
            ".cm-lintRange-warning": {
                // Customize the color of the wavy line beneath a warning using
                // the CSYellow color (#D48103).

                backgroundImage: lintUnderlineImages.warning,
            },
            ".cm-lintRange-error": {
                // Customize the color of the wavy line beneath an error using
                // the core red color (#D92916).

                backgroundImage: lintUnderlineImages.error,
            },
        },
        {
            dark: false,
        },
    );
    const highlightStyle = HighlightStyle.define(lightStyles);
    // Create an extension that combines the theme + syntax highlighting
    return [theme, syntaxHighlighting(highlightStyle)];
};
